import React from 'react';
import styled from 'styled-components/macro';
import { faRedo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  reload: (...args: unknown[]) => unknown;
  className?: string;
  error?: boolean | string | object;
  content?: string;
};

export const ErrorMessage = (props: Props) => {
  const { className = '', error = false, content = '', reload } = props;

  const message = () => {
    if (error) {
      return 'An error has occurred';
    }
    return `Failed to load${content ? ` ${content}` : ''}`;
  };

  return (
    <MessageWrapper className={`${className} error-message`}>
      <MessageText className="message-text">{`${message()}.`}</MessageText>
      <Retry className="retry" onClick={() => reload()}>
        Click to retry
        <RetryIcon icon={faRedo} className="retry-icon" aria-hidden="true" />
      </Retry>
    </MessageWrapper>
  );
};

const MessageWrapper = styled.div`
  width: 100%;
  min-height: 874px;
  text-align: center;
  font-size: 1.5rem;
`;

const Retry = styled.div`
  padding-top: 12px;
  font-size: initial;
  cursor: pointer;
  font-weight: 700;
  color: ${(props) => props.theme.primary3};
`;

const RetryIcon = styled(FontAwesomeIcon)`
  padding-left: 5px;
  font-size: 1.15rem;
`;

const MessageText = styled.div`
  padding-top: 75px;
  color: ${(props) => props.theme.primary3};
`;
